export default __webpack_public_path__ + "static/media/247.904e1853.gif";